import React from 'react';
import { Outlet, RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';

import { Route as InvoiceDetailRoute } from './[invoiceId]/_index';
import { Route as InvoicesRoute } from './_index';
import { Route as CreateInvoiceRoute } from './create/_index';
import { PermissionsFn, PermissionGuard } from '~/core/PermissionGuard';

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsInvoicesPermissions;
};
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  children: [
    { index: true, element: <InvoicesRoute /> },
    { path: ':invoiceId', element: <InvoiceDetailRoute /> },
    {
      path: ':invoiceId/worklease/:workleaseId',
      element: <InvoiceDetailRoute />,
    }, // this route is used when redirecting from the create invoice page, if a reporting worklease has been created
    { path: 'create', element: <CreateInvoiceRoute /> },
    {
      path: 'create/prefill/:prefillInvoiceId',
      element: <CreateInvoiceRoute />,
    }, // this route is used when redirecting from the invoice details page after selecting "Cancel and Redo" invoice, to prefill a new invoice
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
